import { Box, TextField } from "@mui/material";
import PropTypes from "prop-types";
import { useId } from "react";
import SchemeFieldLabel from "./schemeApply/formEngine/widgets/RewampFieldLabel";

/**
 * Figma 91-28282 "Input Fields" label-container — its own static row above
 * the field, never MUI's floating TextField `label` prop (that's what caused
 * the label/placeholder overlap in notes/rewamp/onboarding/BLOCKERS.md B14).
 * `children`-taking adapter over the canonical widget label, so there is one
 * asterisk/aria implementation rather than two.
 */
export const RewampFieldLabel = ({ children, required = false, htmlFor }) => (
  <SchemeFieldLabel label={children} required={required} htmlFor={htmlFor} sx={{ mb: 0.5 }} />
);

RewampFieldLabel.propTypes = {
  children: PropTypes.node.isRequired,
  required: PropTypes.bool,
  htmlFor: PropTypes.string,
};

/**
 * TextField (or Select, via the standard MUI `select` prop) with its label
 * pulled out into RewampFieldLabel above the box, instead of passed to
 * MUI's `label` prop. Box chrome (padding/radius/placeholder color) comes
 * from the `size="onboarding"` MuiTextField variant in rewampTheme.js.
 */
export const RewampFormField = ({ label, required, id, sx, ...textFieldProps }) => {
  const generatedId = useId();
  const fieldId = id || generatedId;

  return (
    <Box sx={sx}>
      <RewampFieldLabel required={required} htmlFor={fieldId}>
        {label}
      </RewampFieldLabel>
      <TextField id={fieldId} required={required} size="onboarding" fullWidth {...textFieldProps} />
    </Box>
  );
};

RewampFormField.propTypes = {
  label: PropTypes.node.isRequired,
  required: PropTypes.bool,
  id: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default RewampFormField;
